import { render, staticRenderFns } from "./advertisementList.vue?vue&type=template&id=0cfdb8d7&"
import script from "./advertisementList.vue?vue&type=script&lang=js&"
export * from "./advertisementList.vue?vue&type=script&lang=js&"
import style0 from "./advertisementList.vue?vue&type=style&index=0&id=0cfdb8d7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports